/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_REALTIME_INFORMATION_RESPONSE = {
	totalEmissions: 6.245,
	operationalEmissions: 2.178,
	embodiedEmissions: 4.067,
	houses: 472,
	kmCarDrive: 14124,
	dataCenters: [
		{ label: "EDC", value: 17665464 },
		{ label: "S1 and S2", value: 122977.38 },
		{ label: "WIN", value: 1555.8 }
	]
};

export const GET_REALTIME_TOTAL_EMISSIONS_RESPONSE = {
	months: [
		{ month: "2026-01", scope2: 1.2, scope3: 0.9, unit: "tCO2e" },
		{ month: "2026-02", scope2: 1.4, scope3: 1.1, unit: "tCO2e" },
		{ month: "2026-03", scope2: 1.6, scope3: 1.2, unit: "tCO2e" },
		{ month: "2026-04", scope2: 1.5, scope3: 1.0, unit: "tCO2e" }
	]
};

export const GET_REALTIME_EMISSIONS_BY_MODEL_TOTAL_RESPONSE = {
	title: "Highest environmental impact - Models",
	barSeries: [
		{
			name: "Environmental Impact",
			bars: [
				{ name: "Dell Inc. Latitude 5420", value: 5051273, unit: "kgCO2" },
				{ name: "Dell Inc. Latitude 5440", value: 2721962, unit: "kgCO2" },
				{ name: "Dell Inc. Latitude 5430", value: 2267962, unit: "kgCO2" },
				{ name: "Dell Inc. Latitude 5450", value: 1950808, unit: "kgCO2" },
				{ name: "Dell Inc. Latitude 5410", value: 1533000, unit: "kgCO2" }
			]
		}
	]
};

export const GET_REALTIME_EMISSIONS_BY_MODEL_PER_DEVICE_RESPONSE = {
	title: "Highest environmental impact - Models (per device)",
	barSeries: [
		{
			name: "Average CO2",
			bars: [
				{ name: "Dell Inspiron 20", value: 38.6, unit: "kgCO2" },
				{ name: "Apple Macbook Air 2015", value: 32.1, unit: "kgCO2" },
				{ name: "Apple Macbook Pro 2018", value: 28.4, unit: "kgCO2" },
				{ name: "Acer Predator Helios", value: 25.3, unit: "kgCO2" },
				{ name: "Apple Macbook Pro 2020", value: 19.9, unit: "kgCO2" }
			]
		}
	]
};

export const GET_REALTIME_EMISSIONS_BY_LOCATION_RESPONSE = {
	title: "Highest environmental impact - Locations",
	barSeries: [
		{
			name: "Environmental Impact",
			bars: [
				{ name: "ES", value: 8737000, unit: "kgCO2" },
				{ name: "PE", value: 2601000, unit: "kgCO2" },
				{ name: "IT", value: 2601000, unit: "kgCO2" },
				{ name: "BR", value: 2417000, unit: "kgCO2" },
				{ name: "DE", value: 1155000, unit: "kgCO2" }
			]
		}
	]
};

export const GET_REALTIME_MANUFACTURERS_EMISSION_RESPONSE = {
	manufacturersEmissions: [
		{
			manufacturer: "DELL Computer Corp",
			parts: 646,
			emissionValue: 6748609.28,
			total: 9880566.94
		},
		{
			manufacturer: "Hewlett Packard Enterprise Company",
			parts: 234,
			emissionValue: 854255.57,
			total: 9880566.94
		},
		{
			manufacturer: "CISCO Systems Inc",
			parts: 290,
			emissionValue: 691158.12,
			total: 9880566.94
		}
	]
};

export const GET_REALTIME_PIE_CHART_CO2_RESPONSE = {
	title: "Resources Emissions",
	PieChartSlice: [
		{ name: "DELL Computer Corp", value: 6748609.28, unit: "kgCo2e" },
		{ name: "Hewlett Packard Enterprise Company", value: 854255.57, unit: "kgCo2e" },
		{ name: "CISCO Systems Inc", value: 691158.12, unit: "kgCo2e" },
		{ name: "Other 17 Manufacturers", value: 20200.14, unit: "kgCo2e" }
	]
};

export const GET_REALTIME_CARBON_INTENSITY_RESPONSE = {
	title: "Carbon Intensities regional Heatmap",
	mapRegions: [
		{
			name: "Germany",
			value: 12,
			unit: "kw/h",
			shortName: "DE",
			pue: 1.2,
			coolingEfficiency: { name: "Cooling Efficiency", value: 12, unit: "kw/h" },
			rvi: 22
		},
		{
			name: "Italy",
			value: 10,
			unit: "kw/h",
			shortName: "IT",
			pue: 1.1,
			coolingEfficiency: { name: "Cooling Efficiency", value: 10, unit: "kw/h" },
			rvi: 18
		}
	]
};

export const GET_REALTIME_ENERGY_CONSUMPTION_RESPONSE = {
	title: "Total over time per location",
	lineSeries: [
		{
			name: "Italy",
			linePoints: [
				{ name: "2024", value: 0.78, unit: "tCO2e" },
				{ name: "2025", value: 1.23, unit: "tCO2e" },
				{ name: "2026", value: 1.0, unit: "tCO2e" }
			]
		},
		{
			name: "Germany",
			linePoints: [
				{ name: "2024", value: 0.65, unit: "tCO2e" },
				{ name: "2025", value: 0.9, unit: "tCO2e" },
				{ name: "2026", value: 1.1, unit: "tCO2e" }
			]
		}
	]
};

export const GET_REALTIME_EMBODIED_EMISSIONS_RESPONSE = {
	title: "Saved lifecycle emissions",
	lineSeries: [
		{
			name: "Total emissions",
			linePoints: [
				{ name: "2024", value: 0.78, unit: "tCO2e" },
				{ name: "2025", value: 1.23, unit: "tCO2e" },
				{ name: "2026", value: 1.0, unit: "tCO2e" }
			]
		}
	]
};
